import React, { useState } from "react";
import { GetAccess } from "../../../utils/RolesandAccess";
import { ViewMoreIcon } from "../../../assets/icons";
import useDeleteData from "../../../hooks/useDeleteData";
import { ScreenClose, ScreenOpen } from "../../../utils/OtherFunctions";
import CreateOrEdit from "./from";
import ViewImplementationChecklist from "./ViewImplementationChecklist";
import axiosInstance from "../../../services/axiosComman";

function ViewMore({ fetcher, data,satusData,id,getCompletion=()=>{},headerId,fetcherHeader }) {
  const { handleDelete } = useDeleteData();
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => {
    ScreenClose({
      link: "implementation-checklist/implementation-list",
      id: data.id,
    })
    setShowMyModal(false)
  };
  const [showFile, setShowFile] = useState(false);
  const handleClose = () => setShowFile(false);
  const [viewData, setViewData] = useState([]);

  async function getViewPage() {
    await axiosInstance.get(`/implementation-checklist/implementation-list/${data?.id}/`)  
      .then((res) => {
        res.data?.data &&
        setViewData(res.data?.data);
      })
      .catch((err) => console.log(err));
  }

  function EditScreen() {
    ScreenOpen({ link: "implementation-checklist/implementation-list", id: data.id });
    setShowMyModal(true);
  }

  return (
    <>
      <div className="hover:drop-shadow-sm mr-2 py-2 px-[14px] rounded-3xl dropdown bg-white cursor-pointer relative">
        <ViewMoreIcon />
        <div className="hidden dropdown-menu">
          <div
            id="modal"
            className="bg-transparent fixed inset-0 flex justify-center items-center "
          ></div>
          <div className="bg-white text-left rounded-xl w-20 absolute -left-20 -top-1">
            <div className="grid p-1 rounded-t">
              <span
                className="p-1 hover:bg-navhover hover:rounded-lg"
                onClick={() => {getViewPage();setShowFile(true)}}
              >
                View
              </span>
              {GetAccess("information_edit") && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg cursor-pointer"
                  onClick={()=>{getViewPage();EditScreen();}}
                >
                  Edit
                </span>
              )}
              {GetAccess("information_delete") && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg"
                  onClick={() => {
                    handleDelete({
                      url: `implementation-checklist/${data?.id}/delete`,
                      data: { data: { id: data?.id } },
                      id: data?.id,
                      value:"",
                      fetcher:()=>{fetcher();getCompletion();fetcherHeader()},
                    });
                  }}
                >
                  Delete
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <CreateOrEdit
        onClose={handleOnClose}
        visible={showMyModal}
        data={viewData}
        refreshData={fetcher}
        satusData={satusData}
        getCompletion={getCompletion}
        fetcherHeader={fetcherHeader}
        id={id}
        headerId={headerId}
      />
      <ViewImplementationChecklist data={viewData} onClose={handleClose} visible={showFile}/>
    </>
  );
}

export default ViewMore;
